import { MultiSelect } from '@/components/Select'
import { Button } from '@/components/ui/button'
import { ClientDto } from 'api/Clients/Types/Client'
import { FilterDescriptor } from 'store/grid'
import { isEmpty } from 'utils/is-empty'

export type SelectClientModalOpenEvent = { filterId?: string; value: boolean }

const getSelectedIds = (value: unknown): string[] => {
  if (value == null) return []
  const values = Array.isArray(value) ? value : [value]

  return values.map(String)
}

export const SelectClientFilter = ({
  filter,
  onFilterChange,
  onClientModalOpen,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  onClientModalOpen: (event: SelectClientModalOpenEvent) => void
}) => {
  const clientsSelected = (filter?.value ?? []) as ClientDto[]
  const selectedIds = clientsSelected.map((x) => x.id)

  if (isEmpty(selectedIds)) {
    return (
      <Button
        variant='outline'
        size='sm'
        onClick={() => onClientModalOpen({ filterId: filter.id, value: true })}
      >
        Choose Clients
      </Button>
    )
  }

  return (
    <MultiSelect
      className='w-full max-w-xs'
      fullWidth
      name={typeof filter.field === 'string' ? filter.field : undefined}
      options={clientsSelected.map((client) => ({
        key: client.id,
        value: client.id,
        label: client.name,
        text: client.name,
      }))}
      showDropdown={false}
      showSearch
      value={selectedIds}
      onFocus={() => onClientModalOpen({ filterId: filter.id, value: true })}
      onChange={(value) => {
        const nextIds = getSelectedIds(value)
        const nextClients = clientsSelected.filter((client) => nextIds.includes(client.id))

        onFilterChange.call(undefined, {
          nextFilter: { ...filter, filterId: filter.id, value: nextClients },
        })
      }}
    />
  )
}
